import React from 'react';
import { mountAxesSubstrate, SubstrateOptions } from '../scripts/substrate-axes';

interface SubstrateVizProps extends SubstrateOptions {
  id?: string;
  className?: string;
}

const SubstrateViz: React.FC<SubstrateVizProps> = ({
  id = 'hero-viz',
  className = 'hero__viz',
  ...opts
}) => {
  const ref = React.useRef<HTMLElement>(null);

  React.useEffect(() => {
    if (!ref.current) return;
    const handle = mountAxesSubstrate(ref.current, {
      sweepDeg: 90,
      periodSec: 24,
      background: 'none',
      viewBoxRadius: 290,
      ...opts,
    });
    return () => {
      handle?.stop();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <aside ref={ref} className={className} id={id} aria-hidden="true" />;
};

export default SubstrateViz;
